var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { width: "100", viewBox: "-160 177 917 1024", overflow: "visible" }
    },
    [
      _c("human", {
        attrs: {
          anim: "flap",
          color: "red",
          keyframe: _vm.keyframe,
          repeat: true
        }
      }),
      _c("human", {
        attrs: {
          anim: "dance",
          color: "aqua",
          keyframe: _vm.keyframe,
          repeat: true,
          x: 1500
        }
      }),
      _c("human", {
        attrs: {
          anim: "punch",
          color: "blue",
          keyframe: _vm.keyframe,
          repeat: true,
          x: 3000
        }
      }),
      _c("human", {
        attrs: {
          anim: "kick",
          color: "plum",
          keyframe: _vm.keyframe,
          repeat: true,
          x: 4500
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }